import React from "react";
import { MessageCircle } from "lucide-react";
import { useStore } from "../../context/StoreContext";
import { t } from "../../lib/i18n";

export const WhatsAppFloat = () => {
  const { lang } = useStore();
  const phone = "095368395820";
  return (
    <a
      data-testid="whatsapp-float"
      href={`https://wa.me/${phone}`}
      target="_blank"
      rel="noopener noreferrer"
      title={t(lang, "contact_whatsapp")}
      className="wa-float fixed bottom-6 end-6 z-50 bg-[#25D366] text-white rounded-full p-4 shadow-lg hover:scale-110 transition-transform"
    >
      <MessageCircle size={26} strokeWidth={2.2} />
    </a>
  );
};
